import { AppTextService } from '@fi-shared/app-text';
import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

@Component({
    selector: 'fi-task-v2-deadline-status',
    templateUrl: './fi-task-v2-deadline-status.component.html',
    styleUrls: ['./fi-task-v2-deadline-status.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-task-v2-deadline-status' },
    standalone: false,
})
export class FiTaskV2DeadlineStatusComponent {
    @Input({ required: true }) deadline: string;
    @HostBinding('class.deadline-overdue') @Input() isOverdue: boolean;

    constructor(
        private appTextService: AppTextService,
        private fiFormatDateService: FiFormatDateService,
    ) {}

    protected getDeadlineStatus(): string {
        if (!this.deadline?.length) return this.appTextService.get('task.no_deadline');

        return (
            this.appTextService.get('task.deadline') + ': ' + this.fiFormatDateService.formatDate(this.deadline, 'date')
        );
    }
}
